import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {
  "title": "JSX Pragma"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "jsx-pragma"
    }}>{`JSX Pragma`}</h1>
    <p>{`Theme UI uses a custom create element function and JSX pragma comments to allow you to style elements with values from your theme using the `}<a parentName="p" {...{
        "href": "/sx-prop"
      }}><inlineCode parentName="a">{`sx`}</inlineCode>{` prop`}</a>{`.`}</p>
    <h2 {...{
      "id": "what-is-jsx"
    }}>{`What is JSX`}</h2>
    <p>{`JSX is an XML-like syntax extension to JavaScript.
It's a syntax sugar usually used for React's `}<inlineCode parentName="p">{`createElement`}</inlineCode>{` function.
You don't need to write JSX to use React, but it's meant to make code more readable, especially for tree structures with attributes.`}</p>
    <p>{`Given the following JSX:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// example JSX
<div>
  <Button onClick={handleClick}>Hello</Button>
</div>
`}</code></pre>
    <p>{`The above JSX syntax compiles to the following:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`React.createElement(
  'div',
  null,
  React.createElement(
    Button,
    {
      onClick: handleClick,
    },
    'Hello'
  )
)
`}</code></pre>
    <p>{`Most apps use Babel to compile JSX syntax for use with React or other similar libraries.
JSX can be compiled to `}<em parentName="p">{`any`}</em>{` function call. By default the Babel plugin will convert JSX into `}<inlineCode parentName="p">{`React.createElement`}</inlineCode>{`, but libraries like Preact, MDX, Emotion, and Vuejs use custom create elements functions with JSX.`}</p>
    <p>{`To change the underlying create element function, you can either add an option to the Babel plugin or you can set a `}<em parentName="p">{`pragma comment`}</em>{` at the beginning of a module.
Changing the function in the Babel plugin will transform all JSX in an application into the same function.
Using a pragma comment limits the change to only the modules that it's added to.
This lets you default to the `}<inlineCode parentName="p">{`React.createElement`}</inlineCode>{` function in most places and use the custom function only where you need it,
giving the author more control over where it's used.`}</p>
    <p>{`Theme UI uses a custom create element function to add the `}<inlineCode parentName="p">{`sx`}</inlineCode>{` and `}<inlineCode parentName="p">{`css`}</inlineCode>{` props in React.
The preferred way of using this function is by adding the custom pragma comment to the top of your file and importing the `}<inlineCode parentName="p">{`jsx`}</inlineCode>{` function from Theme UI.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`/** @jsx jsx */
import { jsx } from 'theme-ui'
`}</code></pre>
    <p>{`See the `}<a parentName="p" {...{
        "href": "/sx-prop"
      }}><inlineCode parentName="a">{`sx`}</inlineCode>{` prop`}</a>{` docs to learn more.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      